// extracted by mini-css-extract-plugin
export default {"review":"Review_review__LSO8F","review_text":"Review_review_text__A6Q+8"};